import React from 'react';
import GrayTag from './_base/GrayTag';

export default function ParticipantTag(props) {
  return (
    <GrayTag label="COLLABORATOR" />
  );
}
